import { Link } from "react-router";
import { listSchrijvenTopics } from "../../../data/schrijven-study/topics";
import { useT } from "../../../lib/use-t";

export function SchrijvenLerenIndexPage() {
  const t = useT();
  const topics = listSchrijvenTopics();

  return (
    <main className="flex-1 mx-auto w-full max-w-3xl lg:max-w-4xl px-5 sm:px-6 py-8 sm:py-12 space-y-8">
      <Link
        to="/schrijven"
        className="inline-flex items-center gap-2 text-sm text-[var(--ink-muted)] hover:text-[var(--ink)] transition-colors"
      >
        <span aria-hidden>←</span>
        <span>{t("schrijven.leren.index.backToSchrijven")}</span>
      </Link>
      <header className="space-y-3">
        <p className="text-xs uppercase tracking-wider text-[var(--ink-faint)] font-mono-badge">
          {t("schrijven.leren.index.eyebrow")}
        </p>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight">
          {t("schrijven.leren.index.title")}
        </h1>
        <p className="font-serif-italic text-lg text-[var(--ink-muted)] max-w-prose">
          {t("schrijven.leren.index.description")}
        </p>
      </header>

      <ul className="space-y-3">
        {topics.map((topic) => (
          <li key={topic.slug}>
            <Link
              to={`/schrijven/leren/${topic.slug}`}
              className="group block rounded-2xl border border-[var(--border)] bg-[var(--panel)] hover:border-[var(--accent)]/40 hover:bg-[var(--panel-soft)] transition-colors p-5 sm:p-6"
            >
              <div className="flex items-baseline justify-between gap-3 mb-1.5">
                <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">
                  {topic.title}
                </h2>
                <span className="font-mono-badge text-xs text-[var(--ink-faint)] shrink-0 tabular-nums">
                  {t("schrijven.leren.index.durationFmt", { duration: topic.duration })}
                </span>
              </div>
              <div className="flex items-end justify-between gap-4">
                <p className="font-serif-italic text-[var(--ink-muted)] flex-1">
                  {topic.summary}
                </p>
                <span
                  aria-hidden
                  className="text-[var(--ink-faint)] opacity-40 group-hover:opacity-100 group-hover:text-[var(--accent)] transition-all translate-x-0 group-hover:translate-x-0.5 shrink-0"
                >
                  →
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      <p className="text-sm text-[var(--ink-faint)] italic">
        {t("schrijven.leren.index.moreChaptersNote")}
      </p>
    </main>
  );
}
